(() => {
  const nudge = document.querySelector('[data-free-delivery-nudge]');
  if (!nudge) return;

  const threshold = Number(nudge.dataset.freeDeliveryThreshold) || 49900;
  const message = nudge.querySelector('[data-free-delivery-message]');
  const count = nudge.querySelector('[data-free-delivery-count]');
  const progress = nudge.querySelector('.free-delivery-nudge__progress span');
  const formatter = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 });

  const render = (cart) => {
    if (!cart.item_count) {
      nudge.hidden = true;
      return;
    }

    const cartTotal = Number(cart.total_price) || 0;
    const remaining = Math.max(threshold - cartTotal, 0);
    const percent = Math.min((cartTotal / threshold) * 100, 100);
    message.textContent = remaining > 0
      ? `Add ₹${formatter.format(Math.ceil(remaining / 100))} more to get FREE DELIVERY`
      : 'FREE DELIVERY AVAILABLE';
    count.textContent = `${cart.item_count} ${cart.item_count === 1 ? 'ITEM' : 'ITEMS'}`;
    progress.style.width = `${percent}%`;
    nudge.hidden = false;
  };

  const refresh = () => {
    fetch(`${window.routes.cart_url}.js`, {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    })
      .then((response) => response.json())
      .then(render)
      .catch(() => {});
  };

  document.addEventListener('cart-count:updated', (event) => {
    const cart = event.detail?.cart;
    if (Number.isFinite(cart?.total_price) && Array.isArray(cart?.items)) {
      render(cart);
      return;
    }

    const itemCount = event.detail?.count;
    if (!Number.isFinite(itemCount)) return;
    count.textContent = `${itemCount} ${itemCount === 1 ? 'ITEM' : 'ITEMS'}`;
    nudge.hidden = itemCount === 0;
  });

  const openCart = () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.open(nudge);
    else window.location.href = window.routes.cart_url;
  };

  nudge.addEventListener('click', (event) => {
    if (event.target.closest('[data-free-delivery-close]')) return;
    openCart();
  });
  nudge.querySelector('[data-free-delivery-close]').addEventListener('click', () => { nudge.hidden = true; });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      const cart = event?.cartData;
      if (Number.isFinite(cart?.total_price) && Number.isFinite(cart?.item_count) && Array.isArray(cart?.items)) {
        render(cart);
        return;
      }
      refresh();
    });
  }
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refresh();
  });
  refresh();
})();
